module.exports = __webpack_public_path__ + "static/media/shell-icon-new.e2e3164a.svg";